import React from 'react';
import { useNavigate } from 'react-router-dom';
import * as DialogPrimitive from '@radix-ui/react-dialog';
import { ArrowLeft } from 'lucide-react';
import './LegalModal.css';

const LegalPageLayout = ({ embedded = false, icon: Icon, title, updated, backLabel, children, testId }) => {
  const navigate = useNavigate();
  const heading = <h1 className="legal-document-title">{title}</h1>;

  return (
    <div className={embedded ? 'legal-document legal-document-embedded' : 'legal-document legal-document-page'}>
      {!embedded && (
        <button className="legal-document-back" onClick={() => navigate('/')} data-testid={testId}>
          <ArrowLeft size={16} /> {backLabel}
        </button>
      )}
      <div className="legal-document-header">
        <Icon size={22} aria-hidden="true" />
        {embedded ? <DialogPrimitive.Title asChild>{heading}</DialogPrimitive.Title> : heading}
      </div>
      <div className="legal-document-scroll">
        <p className="legal-document-updated">{updated}</p>
        <div className="legal-document-body">{children}</div>
      </div>
    </div>
  );
};

export default LegalPageLayout;
